import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import 'process/browser';
import { Buffer } from 'buffer';
import 'semantic-ui-css/semantic.min.css';
import { BrowserRouter } from 'react-router-dom';
import { googleFonts, siteOptions, demoGoogleId, liveGoogleId } from './site/siteSettings';
import App from './App';
import ScrollToTop from './structure/scrollToTop';

// Buffer polyfill - must be after all imports
window.Buffer = Buffer;
global.Buffer = Buffer;

//Pulls in the array of google fonts and puts it nicely in a string to call.
let fonts = googleFonts.join('|').split(' ').join('+')

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop>
      <App />
      <style>
        @import url('{`https://fonts.googleapis.com/css?family=${fonts}&display=swap`}');
          </style>
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById('root'));
